module.exports = __webpack_public_path__ + "static/img/11.6caa58f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/zh/11.png
// module id = bVqb
// module chunks = 0